import React from 'react'
import {ValidationNodeProps, ValidatorWrapper} from './common'
import {MinimumDateValidation} from '../../../common/types/index'
import {TextEditor} from '../../../components/library/text-editor/index'
import {
  useVariablePaths,
  useVariableModal
} from '../../../providers/variables/provider'
import {DateInput} from '../../../components/library/form/date-input'

export const MinimumDate = ({
  attributes,
  enabled,
  updateAttributes,
  toggleEnabled,
  readOnly
}: ValidationNodeProps<MinimumDateValidation>) => {
  const variablePaths = useVariablePaths()
  const [openVariableModal, VariableModal] = useVariableModal()
  return (
    <ValidatorWrapper
      icon="min"
      title="Minimum date"
      enabled={enabled}
      onEnableToggle={isEnabled => toggleEnabled(isEnabled, attributes)}
      readOnly={readOnly}
    >
      <DateInput
        label="Enter minimum date..."
        upLabel="Minimum date"
        value={attributes.minimumDate}
        onChange={minimumDate => {
          updateAttributes({
            ...attributes,
            minimumDate
          })
        }}
        readOnly={readOnly}
      />
      <TextEditor
        label="Add an accompanying message..."
        upLabel="Accompanying message"
        value={attributes.errorMessage ?? ''}
        onChange={errorMessage => {
          updateAttributes({
            ...attributes,
            errorMessage
          })
        }}
        variablePaths={variablePaths}
        openVariableForm={openVariableModal}
        readOnly={readOnly}
        legacyMode={true}
      />
      <VariableModal />
    </ValidatorWrapper>
  )
}
